import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { GitlabService } from '../../gitlab.service';
import { forkJoin, Observable } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { PipelineDetail } from '../pipeline-detail';

@Component({
  selector: 'app-dashboard-active-pipelines',
  templateUrl: './active-pipelines.component.html',
  styleUrls: ['./active-pipelines.component.css']
})
export class ActivePipelinesComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  gitlabInstanceName: string;

  @Input()
  pipelines: PipelineDetail[];

  @Output()
  trackItemEvent: EventEmitter<any> = new EventEmitter<any>();

  // pipelines: any[] = [];
  // intervalSubscription: Subscription;

  constructor(private gitlabService: GitlabService) {
  }


  ngOnInit() {
    // this.loadPipelines();

    // this.intervalSubscription = interval(30000).subscribe(() => this.loadPipelines());
  }

  ngOnChanges(changes: SimpleChanges) {
    // this.loadPipelines();
  }

  ngOnDestroy() {
    // this.intervalSubscription.unsubscribe();
  }

  getStages(pipeline): string[] {
    if (pipeline.jobs) {
      return pipeline.jobs.reduce(
        (accumulator, current) => {
          if (!accumulator.some(stage => stage === current.stage)) {
            accumulator.push(current.stage);
          }
          return accumulator;
        }, []);
    }
    else {
      return [];
    }
  }

  getJobs(pipeline, stage): any[] {
    if (pipeline.jobs) {
      return pipeline.jobs.filter(j => j.stage === stage);
    }
    else {
      return [];
    }
  }

  track(item: any) {
    this.gitlabService.trackProjectBranch(this.gitlabInstanceName, item.project.id, item.project.name_with_namespace, item.pipeline.ref)
      .subscribe(() => {
        this.trackItemEvent.next({
          projectId: item.project.id,
          projectName: item.project.name_with_namespace,
          branch: item.pipeline.ref
        });
      });
  }

  private loadPipelines() {
    // this.pipelines = [];

    if (!this.gitlabInstanceName || this.gitlabInstanceName === '') {
      return;
    }

    this.gitlabService.getRunners(this.gitlabInstanceName, true).subscribe(
      activeRunners => {
        let runnerObservables = [];
        activeRunners.forEach(runner => {
          runnerObservables.push(this.loadRunnerPipelines(runner));
        });

        forkJoin(runnerObservables)
          .pipe(flatMap(pipelines => pipelines))
          .subscribe((pipelines: any[]) => {

            pipelines = this.makeDistinct(pipelines);

            this.pipelines.push(...pipelines);
            this.pipelines = this.makeDistinct(this.pipelines);
            this.pipelines = this.pipelines.sort((p1, p2) => p1.id - p2.id);

            // filter out pipelines which are no longer active anymore
            this.pipelines = this.pipelines.filter(pipeline => {
              return pipeline.pipeline.status === 'running' ||
                ((new Date(pipeline.pipeline.updated_at).getTime() + 120000) > new Date().getTime());
            });

            //
            // update pipeline status for 'old' pipelines
            //
            this.pipelines.forEach(pipeline => {
              if (!pipelines.some(p => p.id === pipeline.id)) {
                this.gitlabService.getPipeline(this.gitlabInstanceName, pipeline.project.id, pipeline.id)
                  .subscribe(p => {
                    pipeline.pipeline = p;
                  })
              }
            });

            this.pipelines.forEach(pipeline => this.loadJobs(pipeline));
            this.pipelines.forEach(pipeline => this.loadTestReport(pipeline));
          });
      }
    )
  }


  private makeDistinct(pipelines: any[]): any[] {
    return pipelines.reduce(
      (accumulator, current) => {
        if (!accumulator.some(x => x.id === current.id)) {
          accumulator.push(current);
        }
        return accumulator;
      }, []
    );
  }

  private loadRunnerPipelines(runner: any): Observable<any[]> {
    return this.gitlabService.getRunnerJobs(this.gitlabInstanceName, runner.id, true)
      .pipe(
        map(jobs => jobs.filter(j => j.status === 'running')),
        map(jobs => jobs.map(j => {
          return {
            id: j.pipeline.id, pipeline: j.pipeline, project: j.project, user: j.user, commit: j.commit, runner: runner
          };
        })),
        map(pipelines => pipelines.reduce(
          (accumulator, current) => {
            if (!accumulator.some(x => x.id === current.id)) {
              accumulator.push(current)
            }
            return accumulator;
          }, []
        )));
  }


  private loadJobs(pipeline: any) {
    this.gitlabService.getPipelineJobs(this.gitlabInstanceName, pipeline.project.id, pipeline.id)
      .subscribe(jobs => pipeline.jobs = jobs);
  }


  private loadTestReport(pipeline: any) {
    this.gitlabService.getPipelineTestReport(this.gitlabInstanceName, pipeline.project.id, pipeline.id)
      .subscribe(report => pipeline.testReport = report);
  }
}
